import './Tooltip-706350cf.css';

var classes = {"Tooltip":"prc-TooltipV2-Tooltip-cYMVY","KeybindingHintContainer":"prc-TooltipV2-KeybindingHintContainer-iabqv","HasTextBefore":"prc-TooltipV2-HasTextBefore-cCzYC"};

export { classes as default };
